import React from "react";
import PrincipalInvestigatorImage from "../../../Images/Atanu_pic2.jpg"
import { Link } from "react-router-dom";

const PrincipalInvestigator = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-5 text-center">
          <div className="card-text mb-auto people py-3">
            <img src={PrincipalInvestigatorImage} alt="" />
          </div>
        </div>
        <div className="col-md-7 p-2">
          <div className="text-bold">Atanu K Metya</div>
          <div className="text-uppercase cbe mt-2 profile">
            Assistant Professor at IIT Patna (2020 - present)
          </div>
          <hr />
          <div>
            <b>Ph.D.</b> Chemical Engineering, Indian Institute of Technology
            Kanpur (2018)
            <br />
            <b>M.Tech.</b> Chemical Engineering, Indian Institute of Technology
            Kanpur (2011)
            <br />
            <b>B.Tech.</b> Chemical Engineering, University College of Science &
            Technology, University of Calcutta (2009)
            <br />
            <b>B.Sc.</b> Chemistry, (Hons.), University of Calcutta (2006)
            <hr />
            <b>Phone: </b> +91 6115 233 831
            <br />
            <b>Email: </b>{" "}
            <a href="mailto:atanu.metya@iitp.ac.in">atanu.metya@iitp.ac.in</a>
          </div>
          <Link className="knowMore" to="/~atanu.metya/details">
            <button type="button" className="btn btn-info mt-3">
              Know More
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrincipalInvestigator;
